module.exports = __webpack_public_path__ + "static/media/37.e1dccb9d.wav";